// 'use client';
// import React, { useEffect, useRef, useState } from 'react';
// import mixitup from 'mixitup';

// const data = [
//   {
//     "img": "/home2/assets/img/projects/projects1.jpg",
//     "subTitle": "Facade System ",
//     "title": "Coxswain23 – Calicut",
//     "desc": "Semi Unitized curtain wall, Spider Glazing,  Façade  Interior Partitions, Glass Work.",
//     "status": "ongoing"
//   },
//   {
//     "img": "/home2/assets/img/projects/vision.jpg",
//     "subTitle": "Interior Fit Out Solutions",
//     "title": "Sound Vision India – Bangalore",
//     "desc": "Interior Turnkey <br /> Complete office interior transformation"
//   },
//   {
//     "img": "/home2/assets/img/projects/ace.jpg",
//     "subTitle": "Facade Solutions",
//     "title": "ACE Center Point Mall – Calicut",
//     "desc": "Glass façade, Canopy, Entry System <br /> Balustrades & railings"
//   },
//   {
//     "img": "/home2/assets/img/projects/projectsstar.jpg",
//     "subTitle": "Partitions",
//     "title": "Starcare Hospital – Calicut",
//     "desc": "Glass Partitions, Canopy, Entry system <br /> Roof Atrium"
//   },
//   {
//     "img": "/home2/assets/img/projects/projects (2).jpg",
//     "subTitle": "Facade Solutions",
//     "title": "Hilite Mall – Calicut",
//     "desc": "Glass façade, Canopy, Entry System <br /> Interior shopfronts for Hilite Interiors"
//   },
//   {
//     "img": "/home2/assets/img/projects/projects (1).avif",
//     "subTitle": "Facade System",
//     "title": "The Garuda Five Star Business Class Hotel – Thrissur",
//     "desc": "Façade, Canopy, Entry System <br /> Interior partitions"
//   },
//   {
//     "img": "/home2/assets/img/projects/projects (2).webp",
//     "subTitle": "Facade Solutions",
//     "title": "ASTER Medicity – Cochin",
//     "desc": "Healthcare facility facade <br /> Glass solutions & Entry systems"
//   },
//   {
//     "img": "/home2/assets/img/projects/cmi.png",
//     "subTitle": "Architectural Hardware Solutions",
//     "title": "CMI – Bangalore",
//     "desc": "Glass Partitions <br /> Hardware's job for Hilite Interiors"
//   },
//   {
//     "img": "/home2/assets/img/projects/parco.png",
//     "subTitle": "Doors & Windows Solutions",
//     "title": "Parco Hospital – Vadakara",
//     "desc": "Glass Partitions, Interior Glass works <br /> Hardware's & UPVC Windows"
//   },
//   {
//     "img": "/home2/assets/img/projects/tulah.webp",
//     "subTitle": "Facade System",
//     "title": "Tulah Clinical Wellness Sanctuary – Kakkancheri",
//     "desc": "Special steel structures, Cladding, Canopy Cladding <br /> Automatic doors, Glass solutions"
//   },
//   {
//     "img": "/home2/assets/img/projects/pkdas.jpg",
//     "subTitle": "Facade System",
//     "title": "PK DAS Institute of Medical Science",
//     "desc": "Special steel structures, Cladding, Canopy Cladding <br /> Automatic doors, Glass solutions"
//   }
// ];

// function LatestCases() {
//   const [activeFilter, setActiveFilter] = useState('All');
//   const mixitupContainerRef = useRef(null);

//   useEffect(() => {
//     const initializeMixitup = () => {
//       if (mixitupContainerRef.current) {
//         mixitup(mixitupContainerRef.current, {
//           load: {
//             sort: 'order:asc',
//           },
//           animation: {
//             duration: 700,
//           },
//           classNames: {
//             block: 'filter',
//             elementFilter: 'filter-btn',
//             elementSort: 'sort-btn',
//           },
//           selectors: {
//             target: '.mix-item',
//           },
//         });
//       }
//     };

//     initializeMixitup();
//   }, []);

//   const handleFilterClick = (filter) => {
//     setActiveFilter(filter);
//   };

//   return (
//     <section className="tc-latest-cases-style1">
//       <div className="container">
//         <div className="content">
//           <h3 className="fsz-45 text-capitalize mb-90 js-splittext-lines">
//             Projects
//           </h3>
//           <div className="cases">
//             <div
//               className="filter mb-60 wow fadeInUp slow"
//               data-wow-delay="0.2s"
//             >
//               <div className="links">
//                 <a
//                   onClick={() => handleFilterClick('All')}
//                   className={`filter-btn ${
//                     activeFilter === 'All' ? 'active' : ''
//                   }`}
//                   href="#0"
//                   data-filter="all"
//                 >
//                   All
//                 </a>
         
//                 <a
//                   href="#0"
//                   onClick={() => handleFilterClick('completed')}
//                   className={`filter-btn ${
//                     activeFilter === 'completed' ? 'active' : ''
//                   }`}
//                   data-filter=".ongoing-projects"
//                 >
//                   Completed Projects
//                 </a>
//                 <a
//                   href="#0"
//                   onClick={() => handleFilterClick('ongoing')}
//                   className={`filter-btn ${
//                     activeFilter === 'ongoing' ? 'active' : ''
//                   }`}
//                   data-filter=".ongoing-projects"
//                 >
//                   Ongoing Projects
//                 </a>
//                 <a
//                   href="#0"
//                   onClick={() => handleFilterClick('upcoming')}
//                   className={`filter-btn ${
//                     activeFilter === 'upcoming' ? 'active' : ''
//                   }`}
//                   data-filter=".upcoming-projects"
//                 >
//                  Upcoming Projects
//                 </a>
                
                
              
//               </div>
//             </div>
//             <div
//               className="cases-content wow fadeInUp slow"
//               data-wow-delay="0.4s"
//             >
//               <div className="row mixitup" ref={mixitupContainerRef}>
//                 {data.map((item, i) => {
//                   // Convert subTitle to lowercase class with hyphens
//                   const filterClass = item.subTitle
//                     .toLowerCase()
//                     .replace(/\s+/g, '-')
//                     .replace(/&/g, '');
                  
//                   return (
//                     <div 
//                       key={i} 
//                       className={`col-lg-4 mix-item ${filterClass}`}
//                     >
//                       <div className="case-card">
//                         <a href={item.img} className="img" data-fancybox="cases">
//                           <img src={item.img} alt="" className="img-cover" />
//                         </a>
//                         <div className="info">
//                           <div className="tags mb-30">
//                             <a href="#"> {item.subTitle} </a>
//                           </div>
//                           <h3 className="title fsz-35 mb-20">
//                             <a href="#" className="hover-orange1">
//                               {item.title}
//                             </a>
//                           </h3>
//                           <div 
//                             className="text color-666"
//                             dangerouslySetInnerHTML={{ __html: item.desc }}
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default LatestCases;


'use client';
import React, { useEffect, useRef, useState } from 'react';
import mixitup from 'mixitup';

const data = [
  {
    "title": "Coxswain23 – Calicut",
    "year": "2015",
    "sub1": "Semi Unitised curtain wall",
    "sub2": "Spider Glazing, Interior Partitions",
    "sub3": "Facade, Glass Work",
    "category": "completed",
    "img": "/home2/assets/img/projects/projects1.jpg"
  },
  {
    "title": "Sound Vision India – Bangalore",
    "year": "2023",
    "sub1": "Interior Fit Out",
    "sub2": "Glass Partitions",
    "sub3": "Architectural Hardware",
    "category": "completed",
    "img": "/home2/assets/img/projects/vision.jpg"
  },
  {
    "title": "Centre Point Mall – Calicut",
    "year": "2017",
    "sub1": "Glass façade, Canopy",
    "sub2": "Entry System",
    "sub3": "Balustrades & railings",
    "category": "completed",
    "img": "/home2/assets/img/projects/ace.jpg"
  },
  {
    "title": "Starcare Hospital – Calicut",
    "year": "2017",
    "sub1": "Glass Partitions, Canopy",
    "sub2": "Entry system",
    "sub3": "Roof Atrium",
    "category": "completed",
    "img": "/home2/assets/img/projects/projectsstar.jpg"
  },
  {
    "title": "Hilite Mall – Calicut",
    "year": "2015",
    "sub1": "Entry System",
    "sub2": "Interior shopfronts for Hilite Interiors",
    "category": "completed",
    "img": "/home2/assets/img/projects/projects (2).jpg"
  },
  {
    "title": "The Garuda Five Star Business Class Hotel – Thrissur",
    "year": "2014",
    "sub1": "Façade, Canopy",
    "sub2": "Entry System",
    "sub3": "Interior partitions",
    "category": "completed",
    "img": "/home2/assets/img/projects/projects (1).avif"
  },
  {
    "title": "ASTER Medicity – Cochin",
    "contract": "Sub-contract for Hilite Interiors LLP",
    "year": "2015",
    "sub1": "Glass Partition",
    "sub2": "Glass works, Entry system",
    "sub3": "Architectural Hardware",
    "category": "completed",
    "img": "/home2/assets/img/projects/projects (2).webp"
  },
  {
    "title": "CMI – Bangalore",
    "contract": "Sub-contract for Hilite Interiors LLP",
    "sub1": "Glass Partitions",
    "sub2": "Hardware's job for Hilite Interiors",
    "sub3": "Commercial Interior Fit-out",
    "category": "completed",
    "img": "/home2/assets/img/projects/cmi.png"
  },
  {
    "title": "Parco Hospital – Vadakara",
    "sub1": "Glass Partitions, Interior Glass works",
    "sub2": "Hardware's & UPVC Windows",
    "sub3": "Healthcare Interior Solutions",
    "category": "completed",
    "img": "/home2/assets/img/projects/parco.png"
  },
  {
    "title": "Tulah Clinical Wellness Sanctuary – Kakkancheri",
    "year": "2025",
    "sub1": "Canopy Cladding",
    "category": "completed",
    "img": "/home2/assets/img/projects/tulah.jpg"
  },
  {
    "title": "PK DAS Institute of Medical Science – Hospital and Medical College",
    "sub1": "Facade Solutions",
    "sub2": "Glass Works",
    "category": "completed",
    "img": "/home2/assets/img/projects/pkdas.jpg"
  }
];

function LatestCases() {
  const [activeFilter, setActiveFilter] = useState('all');
  const mixitupContainerRef = useRef(null);

  useEffect(() => {
    if (mixitupContainerRef.current) {
      mixitup(mixitupContainerRef.current, {
        selectors: { target: '.mix-item' },
        animation: {
          duration: 700,
          effects: 'fade translateY(20%)',
        },
      });
    }
  }, []);

  return (
    <section className="tc-latest-cases-style1">
      <div className="container">
        <div className="content">
          <h3 className="fsz-45 text-capitalize mb-90 js-splittext-lines">
            Projects
          </h3>

          {/* Filter Buttons */}
          <div className="filter mb-60 wow fadeInUp slow" data-wow-delay="0.2s">
            <div className="links">
              {['all', 'completed', 'ongoing', 'upcoming'].map((filter) => (
                <a
                  key={filter}
                  href="#0"
                  className={`filter-btn ${activeFilter === filter ? 'active' : ''}`}
                  data-filter={filter === 'all' ? 'all' : `.${filter}`}
                  onClick={() => setActiveFilter(filter)}
                >
                  {filter === 'all'
                    ? 'All'
                    : `${filter.charAt(0).toUpperCase() + filter.slice(1)} Projects`}
                </a>
              ))}
            </div>
          </div>

          {/* Project Items */}
          <div className="cases-content wow fadeInUp slow" data-wow-delay="0.4s">
            <div className="row mixitup" ref={mixitupContainerRef}>
              {data.map((item, i) => (
                <div key={i} className={`col-lg-4 mix-item ${item.category}`}>
                  <div className="case-card">
                    <a href={item.img} className="img" data-fancybox="cases">
                      <img src={item.img} alt={item.title} className="img-cover" />
                    </a>
                    <div className="info">
                      <div className="tags mb-30">
                        <a href="#"> {item.category} </a>
                        {item.contract && <a href="#">{item.contract}</a>}
                      </div>
                      <h3 className="title fsz-35 mb-20">
                        <a href="#" className="hover-orange1">
                          {item.title}
                        </a>
                      </h3>
                      
                      <div className="text color-666">
                        {item.sub1 && <div>{item.sub1}</div>}
                        {item.sub2 && <div>{item.sub2}</div>}
                        {item.sub3 && <div>{item.sub3}</div>}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LatestCases;
